<div class="accountinfo-background">
  <h2>C-World</h2>

  <p>Pharmakon Software GmbH</p>

  <br />

  <table>
    <tr>
      <td>{{ 'GENERAL.USERNAME' | translate }}</td>
      <td><span [ngClass]="loading ? 'icon-spinner icon-spin' : ''"></span>{{ data['username'] }}</td>
    </tr>
    <tr>
      <td>{{ 'GLOBAL.GENERAL.C-WORLD-VERSION' | translate }}</td>
      <td>{{ data['version'] }}</td>
    </tr>
    @if (data['host']) {
      <tr>
        <td>Datenbank Server</td>
        <td>{{ data['host'] }}</td>
      </tr>
    }
    <tr>
      <td>{{ 'GLOBAL.GENERAL.DATABASE' | translate }}</td>
      <td>{{ data['database'] }}</td>
    </tr>
    <tr>
      <td>{{ 'GLOBAL.GENERAL.RELEASEDATE' | translate }}</td>
      <td>{{ data['releasedate'] }}</td>
    </tr>
    @if (data['backendTag'] != 'notSet') {
      <tr>
        <td>Backend Tag</td>
        <td>{{ data['backendTag'] }}</td>
      </tr>
    }
    @if (data['frontendTag'] != 'notSet') {
      <tr>
        <td>Frontend Tag</td>
        <td>{{ data['frontendTag'] }}</td>
      </tr>
    }
    @if (mailAddress != '') {
      <tr>
        <td>{{ 'GLOBAL.GENERAL.SUPPORT' | translate }}</td>
        <td>
          <a href="mailto:{{ mailAddress }}?subject={{ 'GLOBAL.GENERAL.SUPPORTSUBJECT' | translate }}">{{
            mailAddress
          }}</a>
        </td>
      </tr>
    }
    <tr>
      <td>{{ 'GLOBAL.GENERAL.BACKENDURL' | translate }}</td>
      <td class="accountinfo-url">{{ backendUrl }}</td>
    </tr>
    @if (data['debug']) {
      <tr>
        <td></td>
        <td><b>Debug-Modus im Backend aktiv.</b></td>
      </tr>
    }
    @if (!data['hash']) {
      <tr>
        <td></td>
        <td><b style="color: white">Backend Code verändert.</b></td>
      </tr>
    }
  </table>

  <br />

  <div class="cw-flex-row">
    <phscw-global-settings></phscw-global-settings>
  </div>
</div>
